import clsx from 'clsx';
import styles from './ProgressBar.module.css';

function ProgressBar({ percent, className, ...rest }) {
    return (
        <div {...rest} className={clsx(styles.wrapper, className)}>
            <div className={clsx(styles.all)}>
                <div
                    className={clsx(styles.current)}
                    style={{ width: `${percent}%` }}
                ></div>
            </div>
        </div>
    );
}
export default ProgressBar;
